// CAM-1533 Super Secretary: the committee a Super Secretary is currently working on is sent on
// every API request in this header (API: App\Http\Middleware\Api -> ActingCommitteeService).
export const ACTING_COMMITTEE_HEADER = 'X-Acting-Committee'
export const ACTING_COMMITTEE_STORAGE_KEY = 'actingCommittee'



// WEBPACK FOOTER //
// ./src/constants/actingCommittee.js